export const householdConstants = {
  // GET_ALL: 取得所有戶別
  GET_ALL_REQUEST: "HOUSEHOLD_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "HOUSEHOLD_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "HOUSEHOLD_GET_ALL_FAILURE",
  RESET_ALL_SUCCESS: "HOUSEHOLD_RESET_ALL_SUCCESS",
  // GET_HOUSEHOLD_EDIT: 取得戶別編輯資料
  GET_HOUSEHOLD_EDIT_REQUEST: "HOUSEHOLD_GET_HOUSEHOLD_EDIT_REQUEST",
  GET_HOUSEHOLD_EDIT_SUCCESS: "HOUSEHOLD_GET_HOUSEHOLD_EDIT_SUCCESS",
  GET_HOUSEHOLD_EDIT_FAILURE: "HOUSEHOLD_GET_HOUSEHOLD_EDIT_FAILURE",
  RESET_HOUSEHOLD_EDIT_SUCCESS: "HOUSEHOLD_RESET_HOUSEHOLD_EDIT_SUCCESS",
  // EDIT_HOUSEHOLD: 修改戶別
  EDIT_HOUSEHOLD_REQUEST: "HOUSEHOLD_EDIT_HOUSEHOLD_REQUEST",
  EDIT_HOUSEHOLD_SUCCESS: "HOUSEHOLD_EDIT_HOUSEHOLD_SUCCESS",
  EDIT_HOUSEHOLD_FAILURE: "HOUSEHOLD_EDIT_HOUSEHOLD_FAILURE",
  RESET_EDIT_HOUSEHOLD_SUCCESS: "HOUSEHOLD_RESET_EDIT_HOUSEHOLD_SUCCESS",
  // GET_CARD_BY_NUMBER: 依照卡號取得門禁卡資料
  GET_CARD_BY_NUMBER_REQUEST: "HOUSEHOLD_GET_CARD_BY_NUMBER_REQUEST",
  GET_CARD_BY_NUMBER_DONE: "HOUSEHOLD_GET_CARD_BY_NUMBER_DONE",
  // GET_LIST: 取得戶別列表
  GET_LIST_REQUEST: "HOUSEHOLD_GET_LIST_REQUEST",
  GET_LIST_SUCCESS: "HOUSEHOLD_GET_LIST_SUCCESS",
  GET_LIST_FAILURE: "HOUSEHOLD_GET_LIST_FAILURE",
  RESET_LIST_SUCCESS: "HOUSEHOLD_RESET_LIST_SUCCESS",
  // SETTING_HOUSEHOLD_USER: 設定住戶參數
  SETTING_HOUSEHOLD_USER_CONFIG_REQUEST: "HOUSEHOLD_SETTING_HOUSEHOLD_USER_CONFIG_REQUEST",
  SETTING_HOUSEHOLD_USER_CONFIG_DONE: "HOUSEHOLD_SETTING_HOUSEHOLD_USER_CONFIG_DONE"
};
